'use client';

import { BlockStack, InlineStack, SkeletonThumbnail, SkeletonBodyText } from '@shopify/polaris';

import Providers from '@/features/asset-providers/Providers';
import usePageNavigation from '@/hooks/usePageNavigation';
import { Page } from '@/components/Page';
import { INTEGRATIONS } from '@/constants/text';

const IntegrationsPage = () => {
  const { navigateBack, previousPageTitle } = usePageNavigation();

  return (
    <>
      <Page backAction={{ content: previousPageTitle, onAction: navigateBack }} title={INTEGRATIONS}>
        <BlockStack gap="600">
          <InlineStack gap="400">
            <Providers />
          </InlineStack>
        </BlockStack>
      </Page>
    </>
  );
};

export default IntegrationsPage;
